import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { forYouItems, notForYouItems } from '../data/forWho';
export function ForWhoSection() {
  return <section aria-label="À qui s’adresse la collection" className="bg-brand-ivory px-4 py-20 md:py-28" data-id="element-104" data-mp="2h66tb8cy65p5">
      <Reveal className="mx-auto grid max-w-6xl gap-5 md:grid-cols-2" data-id="element-105" data-mp="2c7x218ucfp8t">
        <article className="overflow-hidden rounded-2xl bg-white shadow-sm" data-id="element-106" data-mp="2c5j3ur4d9wx1">
          <h2 className="bg-brand-teal-ink px-6 py-4 text-sm font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-107" data-mp="2873dcd92u6ev">
            POUR VOUS SI…
          </h2>
          <ul className="divide-y divide-brand-line" data-id="element-108" data-mp="1y6szqrj4qwz6">
            {forYouItems.map(item => <li key={item} className="flex items-start gap-3 px-6 py-4" data-id="element-109" data-mp="1t9azdpj6hq2s">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-turquoise/15 text-brand-teal-ink" data-id="element-110" data-mp="3sldeyooom0b6">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-111" data-mp="3nn24qcuh5nsf" />
                </span>
                <span className="text-sm font-semibold leading-snug text-slate-800" data-id="element-112" data-mp="1s99spmccmvqr">{item}</span>
              </li>)}
          </ul>
        </article>
        <article className="overflow-hidden rounded-2xl bg-white shadow-sm" data-id="element-113" data-mp="1ic59nvdsvge6">
          <h2 className="bg-slate-100 px-6 py-4 text-sm font-extrabold uppercase tracking-[0.12em] text-slate-600" data-id="element-114" data-mp="1ie9hupiqf1k9">
            CE N’EST PAS…
          </h2>
          <ul className="divide-y divide-brand-line" data-id="element-115" data-mp="2b1vmm13p4c8p">
            {notForYouItems.map(item => <li key={item} className="flex items-start gap-3 px-6 py-4" data-id="element-116" data-mp="2fycdv466z6q0">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-900/5 text-slate-600" data-id="element-117" data-mp="21bj3mdbj4r4o">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-118" data-mp="26817laz1clfy" />
                </span>
                <span className="text-sm leading-snug text-slate-600" data-id="element-119" data-mp="2txvkfsjcua07">{item}</span>
              </li>)}
          </ul>
        </article>
      </Reveal>
    </section>;
}